import { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import ButtonBase from "@mui/material/ButtonBase";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import CheckIcon from "@mui/icons-material/Check";
import { useDispatch, useSelector } from "react-redux";
import { findByUsuario } from "../../../components/AlunoResponsavel/api-aluno-responsavel";
import { changeARAluno } from "../../../components/Usuario/api-usuario";
import { setUsuario } from "../../../components/Usuario/actions/actions";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import { success } from "../../../util/ToastUtil";
import { splitUtil } from "../../../util/StringUtil";

/** Seletor do aluno ativo, exibido na barra superior para responsáveis. */
const AlunoSelectorMenu = () => {
  const usuario = useSelector((state) => state.usuario);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [listaAR, setListaAR] = useState([]);
  const usuarioId = usuario?.id;
  const selecionado = usuario?.arAlunoSelecionado;

  useEffect(() => {
    if (!usuarioId) return;
    findByUsuario(usuarioId).then((data) => {
      if (!data) return;
      if (data.error) {
        errorMessage(data.message);
      } else if (Array.isArray(data)) {
        setListaAR(data);
      }
    });
  }, [usuarioId]);

  const handleAtivarAR = (ar) => {
    setAnchorEl(null);
    if (selecionado?.codigo === ar.aluno.codigo) return;
    changeARAluno(ar.aluno).then((data) => {
      if (!data) return;
      if (data.error) {
        errorMessage(data.message);
        return;
      }
      dispatch(setUsuario(data));
      success("Aluno selecionado.");
    });
  };

  if (listaAR.length === 0) return null;

  return (
    <>
      <Tooltip title="Trocar aluno">
        <ButtonBase
          onClick={(event) => setAnchorEl(event.currentTarget)}
          className="no-print"
          sx={{ borderRadius: 5, pl: 0.5, pr: 1.5, py: 0.5, gap: 1, color: "inherit", "&:hover": { bgcolor: "rgba(255,255,255,0.12)" } }}
        >
          <Avatar src={usuario?.alunoFoto?.foto} alt={selecionado?.nome} sx={{ width: 32, height: 32 }} />
          <Typography variant="body2" noWrap sx={{ display: { xs: "none", sm: "block" }, maxWidth: 160 }}>
            {selecionado?.nome ? splitUtil(selecionado.nome, " ", 2) : "Selecionar aluno"}
          </Typography>
        </ButtonBase>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { minWidth: 240, mt: 1 } } }}
      >
        {listaAR.map((ar) => {
          const ativo = selecionado?.codigo === ar.aluno.codigo;
          return (
            <MenuItem key={ar.codigo} selected={ativo} onClick={() => handleAtivarAR(ar)}>
              <ListItemIcon>
                <Avatar src={ar.alunoFoto?.foto} alt={ar.aluno.nome} sx={{ width: 32, height: 32 }} />
              </ListItemIcon>
              <ListItemText primary={ar.aluno.nome} sx={{ ml: 1 }} />
              {ativo && <CheckIcon fontSize="small" color="success" sx={{ ml: 1 }} />}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default AlunoSelectorMenu;
